import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import BottomAccordion from '../../../shared/bottom-accordion/content';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function Accordion(props) {
  const aboutThisPageMarkup = (
    <div>
      <i className="ui icon info circle mrls mrrnull text-size-xl fr mrbs" />
      <p>
        {htmlToReactParser.parse(
          xss(
            props.orgUnit && props.orgUnit.name
              ? APP.LANGUAGE.OrganisationalUnitManageTags.InfoPartOne.replace(
                  '##OrganisationalUnitName##',
                  props.orgUnit.name.trim()
                )
              : ''
          )
        )}
      </p>
    </div>
  );
  const options = [
    {
      title: 'About this page',
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  const activeIndexOfPage = window.localStorage.getItem(`orgTagsActiveIndex-${props.userId}`);
  return (
    <BottomAccordion
      options={options}
      userId={props.userId}
      pagePrefix="orgTagsActiveIndex"
      activeIndex={
        (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
          options[options.length - 1].title.split(' ').join(''),
        ]
      }
    />
  );
}
